import { useMutation, useQuery } from "@apollo/client";

import {
  DOWNLOAD_PUBLIC_FINANCE_INVOICE_PDF_MUTATION,
  GET_PUBLIC_FINANCE_INVOICE_QUERY,
  REQUEST_PUBLIC_FINANCE_INVOICE_CHANGES_MUTATION,
} from "~/api";
import { errorsHandler } from "~/transformers";

export const useGetPublicFinanceInvoice = (
  oemSlug?: string,
  token?: string,
) => {
  const { data, loading, error, refetch } = useQuery(
    GET_PUBLIC_FINANCE_INVOICE_QUERY,
    {
      skip: !oemSlug || !token,
      variables: { oemSlug, token },
      fetchPolicy: "network-only",
      pollInterval: 5000,
    },
  );

  return {
    invoice: data?.getPublicFinanceInvoice ?? null,
    loading,
    error,
    refetch,
  };
};

export const useDownloadPublicFinanceInvoicePdf = () => {
  const [mutate, { loading }] = useMutation(
    DOWNLOAD_PUBLIC_FINANCE_INVOICE_PDF_MUTATION,
  );
  return {
    loading,
    downloadPdf: (oemSlug: string, token: string) =>
      new Promise<string>((resolve, reject) => {
        mutate({ variables: { oemSlug, token } })
          .then(({ data }) => resolve(data?.downloadPublicFinanceInvoicePDF))
          .catch((err) => reject(errorsHandler(err)));
      }),
  };
};

export const useRequestPublicFinanceInvoiceChanges = () => {
  const [mutate, { loading }] = useMutation(
    REQUEST_PUBLIC_FINANCE_INVOICE_CHANGES_MUTATION,
  );
  return {
    loading,
    requestChanges: (input: {
      oemSlug: string;
      token: string;
      message: string;
    }) =>
      new Promise((resolve, reject) => {
        mutate({ variables: { input } })
          .then(({ data }) => resolve(data?.requestPublicFinanceInvoiceChanges))
          .catch((err) => reject(errorsHandler(err)));
      }),
  };
};
